export var EVENT_TYPE;
(function (EVENT_TYPE) {
    EVENT_TYPE["STOCK_DISPLAY"] = "Voorraad voertuigoverzichtweergave";
    EVENT_TYPE["VEHICLE_DISPLAY"] = "Voorraad voertuigdetailweergave";
})(EVENT_TYPE || (EVENT_TYPE = {}));
export var APP_MODULE;
(function (APP_MODULE) {
    APP_MODULE["MAXUS"] = "Maxus";
})(APP_MODULE || (APP_MODULE = {}));
export default class GrainTrackingService {
    static ensureDataLayerExists() {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
    }
    static track(eventData) {
        GrainTrackingService.ensureDataLayerExists();
        if (window.dataLayer) {
            window.dataLayer.push(eventData);
        }
        else {
            console.error('window.dataLayer is not defined.');
        }
    }
}
